export class GSDIntlTelInputCountry {
  name: string;
  tag:  string;
  code: string;
  flagClass: string;
  placeHolder: string;
  
  constructor() {
  }
}

export class GSDPhoneNumber {

  countryTag: string;
  code: string;
  number: string;
  friendly: string;
  full: string;
  valid: GSDPhoneValidationCodes;

  constructor() {
  }
}

export enum GSDPhoneValidationCodes {

    INVALID = 0,
    REQUIRED = 1,
    VALID = 2,
}